<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <a href="/">
    <img
      src="../../assets/images/logo.png" class="logo"
      srcset="../../assets/images/logo@2x.png 2x,
             ../../assets/images/logo@3x.png 3x" alt="고시락 로고" />
  </a>
</template>

<script>
  export default {
    name: 'logo.vue',
    data () {
      return {

      }
    }
  }
</script>

<style scoped>
  a {
    width: 12.85rem;
    height: 4.7rem;
    /*background-color: grey;*/
    display: inline-block;
    vertical-align: middle;
  }
</style>
